/****   request.js   ****/
// 导入axios
import axios from 'axios'
import { getToken } from '@/utils/auth';
import { Toast } from 'vant';
import { UserModule } from '@/store/store_modular/user'

const baseUrl = process.env.NODE_ENV === 'development' ? '/' : '';
//1. 创建新的axios实例，
const service = axios.create({
	baseURL:baseUrl,
	timeout: 20000,
	withCredentials: true // send cookies when cross-domain requests
});
// service.defaults.headers.post['Content-type'] = 'application/x-www-form-urlencoded;charset=UTF-8';
// 2.在发送请求之前做些什么
service.interceptors.request.use(
	(config) => {
		if (getToken() && UserModule.token) {
			// config.headers['Authorization'] = 'Bearer ' + getToken();
      config.headers = {
        'Content-Type':'application/json', //配置请求头
        'Authorization': 'Bearer ' + getToken(),
      }
		}
		return config;
	},
	error => {
		// 对请求错误做些什么
		return Promise.reject(error);
	}
);

// 3.响应拦截器
// 添加响应拦截器
service.interceptors.response.use(
	response => {
		// Some example codes here:
		// code == 200: success
		// code == 201: Created
		// code == 401: Unauthorized
		// code == 403: Forbidden
		// code == 404: Not Found
		// code == 506: 未登录 或者失效
		const res = response.data;
		if (res.code === 200) {
			return response.data;
		} else if (res.code === 401 || res.msg === '登录状态已过期') {
			UserModule.LogOut();
			Toast(res.msg);
			return Promise.reject(new Error(res.msg));
		} else if (res.code === 403) {
			// 代码遗留
			return response.data;
		} else {
			UserModule.LogOut(); // 表示重新登录
			Toast({
				message: `${res.msg || '登录信息已过期，请重新登录'}`,
				duration: 3000,
			});
			// return Promise.reject(new Error(res.msg || '系统未知错误，请反馈给管理员'));
		}
	},
	error => {
		Toast(error.message);
		return Promise.reject(error);
	},
);
//4.导入文件
export default service
